import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { ArrowLeft, ShoppingBag } from 'lucide-react'
import Footer from '../components/Footer'

interface ShopProps {
  onBack: () => void
}

const Shop: React.FC<ShopProps> = ({ onBack }) => {
  const [selectedCategory, _setSelectedCategory] = useState('all')

  // @ts-ignore
  const _categories = [
    { id: 'all', name: 'Все товары', icon: ShoppingBag },
    //{ id: 'exchange', name: 'Обмен', icon: Star },
    //{ id: 'family', name: 'Семейные', icon: Users },
    //{ id: 'boost', name: 'Бусты', icon: Zap }
  ]

  const products = [
    {
      id: 1,
      name: 'Секретный бокс',
      description: 'Рандомный предмет из Secret Box, что Вам выпадет?',
      purchaseDescription: 'После покупки вы получите рандомный предмет из Secret Box, что Вам выпадет? Может зажигалка, ремка, бинт, или что-то ещё...',
      price: 200,
      category: 'exchange',
      image: '/content/Shop/secret_box.png'
    },
    {
      id: 2,
      name: 'Шью в соло!',
      description: 'Вы получаете возможность выполнить контракт ателье самостоятельно и получить за это 190.000$',
      purchaseDescription: 'После покупки вы сможете выполнить контракт ателье в одиночку и получить 190.000$. Контракт будет доступен в течение 7 дней.',
      price: 300,
      category: 'boost',
      image: '/content/Shop/shveyka.png'
    },
    {
      id: 3,
      name: '+15% к премии контрактов',
      description: '+15% к премии 3 ближайших ваших контрактов',
      purchaseDescription: 'Руководство получит уведомление о покупке и первые 3 ваших контракта будут премированы на +15%',
      price: 500,
      category: 'boost',
      image: '/content/Shop/+15%.png'
    }
  ]

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // @ts-ignore
  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(product => product.category === selectedCategory)




  return (
    <div className="min-h-screen flex flex-col px-4">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="fixed top-0 left-0 right-0 z-40 bg-dark-900/80 backdrop-blur-xl py-4"
      >
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          {/* Кнопка назад */}
          <motion.button
            onClick={onBack}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="w-10 h-10 rounded-xl bg-white/10 border border-white/20 text-gray-200 hover:text-white hover:bg-white/15 flex items-center justify-center"
            aria-label="Назад"
          >
            <ArrowLeft size={18} />
          </motion.button>

          {/* Заголовок */}
          <div className="flex items-center space-x-3">
            <ShoppingBag className="text-orange-500" size={24} />
            <h1 className="text-2xl font-bold text-white">Магазин HUGO</h1>
          </div>

          {/* Пустое место для баланса */}
          <div className="w-10"></div>
        </div>
      </motion.div>

      {/* Основной контент */}
      <div className="flex-1 flex items-center justify-center pt-24">
        {/* Страница "В разработке" */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-2xl mx-auto"
        >
        {/* Анимированная иконка */}
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="mb-8"
        >
          <motion.div
            animate={{ 
              rotate: [0, 10, -10, 0],
              scale: [1, 1.1, 1]
            }}
            transition={{ 
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            className="text-8xl mb-6"
          >
            🔧
          </motion.div>
        </motion.div>

        {/* Заголовок */}
        <motion.h1
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 bg-clip-text text-transparent mb-6"
        >
          В разработке
        </motion.h1>

        {/* Подзаголовок */}
        <motion.p
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.8 }}
          className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed"
        >
          Магазин HUGO Family временно недоступен
        </motion.p>

        {/* Описание */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.8 }}
          className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-xl rounded-3xl p-8 border border-white/10 mb-8"
        >
          <p className="text-gray-400 text-lg leading-relaxed mb-4">
            Мы работаем над разработкой нашего магазина и добавляем новые функции для лучшего опыта членов семьи.
          </p>
          <p className="text-gray-500 text-base">
            Следите за обновлениями в нашем Discord сервере!
          </p>
        </motion.div>
        {/* Кнопка назад */}
        <motion.button
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.1, duration: 0.8 }}
          whileHover={{ scale: 1.05, y: -2 }}
          whileTap={{ scale: 0.95 }}
          onClick={onBack}
          className="bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 text-white px-8 py-4 rounded-2xl font-semibold text-lg hover:from-orange-600 hover:via-red-600 hover:to-pink-600 transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          Вернуться на главную
        </motion.button>

        {/* Дополнительная информация */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.3, duration: 0.8 }}
          className="mt-12 text-gray-500 text-sm"
        >
          <p>Ожидаемое время запуска: Скоро</p>
        </motion.div>
        </motion.div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default Shop
